import { SearchModel } from './common';

// Tipos para fornecedores conforme API Documentation atualizada
export interface Provider {
  provider_id: number; // ✨ Alterado: era "id"
  document: string; // CPF (11) ou CNPJ (14)
  legal_name: string; // ✨ Alterado: era "name"
  trade_name?: string; // ✨ Novo: era "supplier_name"
  pix_key?: string;
  state_registration_tax_id?: string; // Inscrição estadual
  non_contributor_state_registration_tax_id?: boolean; // ✨ Novo campo
  person_type?: 1 | 2; // 1 = PF, 2 = PJ
  addr_street?: string;
  addr_num?: string; // ✨ Alterado: era "addr_number"
  addr_compl?: string; // ✨ Alterado: era "addr_complement"
  addr_district?: string; // ✨ Alterado: era "addr_neighborhood"
  addr_city?: string;
  addr_state?: string; // UF
  addr_zip?: string; // CEP
  addr_country?: string; // ✨ Novo campo
  phone?: string;
  email?: string;
  created_at?: string;
  updated_at?: string;
  is_active: boolean; // ✨ Novo campo obrigatório
}

export interface ProviderFormData {
  document: string;
  legal_name: string; // ✨ Alterado: era "name"
  trade_name?: string; // ✨ Alterado: era "supplier_name"
  pix_key?: string;
  state_registration_tax_id?: string;
  non_contributor_state_registration_tax_id?: boolean; // ✨ Novo campo
  person_type?: 1 | 2;
  addr_street?: string;
  addr_num?: string; // ✨ Alterado: era "addr_number"
  addr_compl?: string; // ✨ Alterado: era "addr_complement"
  addr_district?: string; // ✨ Alterado: era "addr_neighborhood"
  addr_city?: string;
  addr_state?: string;
  addr_zip?: string;
  addr_country?: string; // ✨ Novo campo
  phone?: string;
  email?: string;
}

// Interface extendida para formulários - DEPRECATED, usar ProviderFormData
export interface ProviderExtendedFormData {
  document?: string;
  legal_name?: string; // ✨ Alterado: era "name"  
  trade_name?: string; // ✨ Alterado: era "supplier_name"
  federal_tax_id?: string; // Mapeado para document
  state_tax_id?: string; // Mapeado para state_registration_tax_id
  company_name?: string; // Mapeado para legal_name
  address?: string; // Mapeado para addr_street
  address_number?: string; // Mapeado para addr_num
  complement?: string; // Mapeado para addr_compl
  neighborhood?: string; // Mapeado para addr_district  
  city: string; // Mapeado para addr_city
  state: string; // Mapeado para addr_state
  postal_code?: string; // Mapeado para addr_zip
  phone?: string;
  email?: string;
  bank_name?: string;
  bank_branch?: string;
  bank_account?: string;
  bank_account_digit?: string;
  account_holder_name?: string;
  account_holder_document?: string;
  pix_key?: string;
  pix_key_type?: string;
  is_active: boolean;
}

export interface ProviderSearchModel extends SearchModel {
  searchDocument?: string;
  searchEmail?: string;
  state?: string;
  personType?: 1 | 2;
}

// Fornecedor com preços de produtos relacionados
export interface ProviderWithProducts extends Provider {
  product_prices: {
    id: number;
    product_id: number;
    product_sku: string;
    product_description: string;
    price: number;
    created_at: string;
    updated_at: string;
  }[];
}

// Estados brasileiros para o select
export const BRAZILIAN_STATES = [
  { value: 'AC', label: 'Acre' },
  { value: 'AL', label: 'Alagoas' },
  { value: 'AP', label: 'Amapá' },
  { value: 'AM', label: 'Amazonas' },
  { value: 'BA', label: 'Bahia' },
  { value: 'CE', label: 'Ceará' },
  { value: 'DF', label: 'Distrito Federal' },
  { value: 'ES', label: 'Espírito Santo' },
  { value: 'GO', label: 'Goiás' },
  { value: 'MA', label: 'Maranhão' },
  { value: 'MT', label: 'Mato Grosso' },
  { value: 'MS', label: 'Mato Grosso do Sul' },
  { value: 'MG', label: 'Minas Gerais' },
  { value: 'PA', label: 'Pará' },
  { value: 'PB', label: 'Paraíba' },
  { value: 'PR', label: 'Paraná' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'PI', label: 'Piauí' },
  { value: 'RJ', label: 'Rio de Janeiro' },
  { value: 'RN', label: 'Rio Grande do Norte' },
  { value: 'RS', label: 'Rio Grande do Sul' },
  { value: 'RO', label: 'Rondônia' },
  { value: 'RR', label: 'Roraima' },
  { value: 'SC', label: 'Santa Catarina' },
  { value: 'SP', label: 'São Paulo' },
  { value: 'SE', label: 'Sergipe' },
  { value: 'TO', label: 'Tocantins' }
] as const;

// Aliases para compatibilidade
export type ProviderFilters = ProviderSearchModel;
export type CreateProviderRequest = ProviderFormData;

// Interface extendida com campos adicionais usados nos componentes
export interface ProviderExtended extends Provider {
  federal_tax_id: string;
  state_tax_id?: string;
  company_name: string;
  trade_name?: string;
  address?: string;
  address_number?: string;
  complement?: string;
  neighborhood?: string;
  city: string;
  state: string;
  postal_code?: string;
  bank_name?: string;
  bank_account?: string;
  bank_branch?: string;
  bank_account_digit?: string;
  account_holder_name?: string;
  account_holder_document?: string;
  pix_key_type?: string;
  is_active: boolean;
}

// Opções para tipo de pessoa
export const PERSON_TYPE_OPTIONS = [
  { value: 1, label: 'Pessoa Física' },
  { value: 2, label: 'Pessoa Jurídica' }
] as const;

/**
 * Contraparte bancária do fornecedor: CPF/CNPJ pelo qual o banco o identifica
 * no extrato além do documento do cadastro (CPF da sócia, outra filial).
 * Espelho de ERPApi/internal/core/domain/bank_statement_supplier.go.
 */
export interface ProviderBankCounterpart {
  id: number;
  providerId: number;
  /** Só dígitos. */
  document: string;
  name: string;
  source: 'learned' | 'manual';
  createdAt?: string;
  createdBy?: string;
}
